import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Typography, Statistic } from 'antd';
import {FilterComponent, ComponentTitle} from './FilterComponent';
import { applyAllFilters } from './utils'; // Ensure this is correctly imported
const { Text } = Typography;

const cardStyle = {
  width: '100%',
  textAlign: 'left',
  padding: '10px',
  border: 'none',
  borderBottomLeftRadius: '8px',
  boxShadow: 'none'
}



const Filters = ({ data, configs, onFilterChange }) => {
  const [filters, setFilters] = useState({});

  useEffect(() => {
    const initialFilters = configs.reduce((acc, config) => {
      const keyPath = typeof config.key === 'string' ? config.key : config.key.join('.');
      if (config.hasOwnProperty('init')) {
        acc[keyPath] = config.init;
      }
      return acc;
    }, {});
    setFilters(initialFilters);
  }, [configs]);

  const handleFilterChange = (keyPath, value) => {
    const updatedFilters = { ...filters, [keyPath]: value };
    setFilters(updatedFilters);
    const filteredData = applyAllFilters(data, updatedFilters, configs);
    onFilterChange(filteredData);
  };

  return (
    <div>
      <Row gutter={[16, 16]}>
        {/* Filters Column */}
        <Col xs={24} sm={24} md={12} lg={16}>
          <Row gutter={[16, 16]}>
            {configs.map((config, index) => {
              const keyPath = typeof config.key === 'string' ? config.key : config.key.join('.');
              return (
                <Col xs={24} sm={12} md={8} lg={8} key={keyPath}>
                  <Card.Grid style={cardStyle}>
                    <FilterComponent
                      config={config}
                      data={data}
                      onFilterChange={(_, value) => handleFilterChange(keyPath, value)}
                    />
                  </Card.Grid>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default Filters;
